import React from 'react';
import PropTypes from 'prop-types';
import Symbol from '../../../../webcommon/common/symbols/Symbol';
import Tooltip from 'rc-tooltip';
import defaultStyles from './HeaderCell.module.scss';
import 'rc-tooltip/assets/bootstrap.css';

const HeaderCell = props => (
    <div className={ props.styles.headerText }>
        <div className={ props.styles.filler } />
        <div className={ props.styles.symbolHeaderContent }>
            <Tooltip
                placement="bottomLeft"
                overlay={ props.toolTipMessage }
                arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
            >
                <div href="#"><Symbol symbol={ props.symbol }>{props.value}</Symbol></div>
            </Tooltip>
        </div>
    </div>
);

HeaderCell.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    symbol: PropTypes.string,
    toolTipMessage: PropTypes.string,
    value: PropTypes.string
};

HeaderCell.defaultProps = {
    styles: defaultStyles,
    symbol: '',
    toolTipMessage: '',
    value: ''
};

export default HeaderCell;
